import type { RequiredGeneric } from '@pba/utils';
import { Col, Fieldset, Row, TextInput } from 'ui';

export type NameFormValues = {
  firstName: string;
  lastName: string;
  middleName?: string;
};

type P = {
  withMiddleName?: boolean;
};

const NameFieldset = <FormValues extends NameFormValues = never>({
  withMiddleName = true,
}: RequiredGeneric<FormValues, P>) => {
  const surnameSpan = withMiddleName ? 24 : 12;

  return (
    <Fieldset legend={{ title: 'Full name' }}>
      <Row gutter={['xs', 'xs']}>
        <Col span={12}>
          <TextInput<NameFormValues>
            input={{
              autoComplete: 'given-name',
            }}
            item={{
              label: 'First name',
              name: 'firstName',
              rules: [
                {
                  required: true,
                },
              ],
            }}
          />
        </Col>
        {withMiddleName ? (
          <Col span={12}>
            <TextInput<NameFormValues>
              item={{
                label: 'Middle name',
                name: 'middleName',
              }}
            />
          </Col>
        ) : null}
        <Col span={surnameSpan}>
          <TextInput<NameFormValues>
            input={{
              autoComplete: 'family-name',
            }}
            item={{
              label: 'Last name',
              name: 'lastName',
              rules: [
                {
                  required: true,
                },
              ],
            }}
          />
        </Col>
      </Row>
    </Fieldset>
  );
};

export default NameFieldset;
